import * as THREE from 'three';

export function createStars(scene) {
  const object = scene.getObjectByName('stars');

  if (object) {
    return scene;
  }

  const starCount = 2200;
  const positions = new Float32Array(starCount * 3);

  randomPointsOnSphere(starCount, 42, 78).forEach((value, index) => {
    positions[index] = value;
  });

  const starsGeometry = new THREE.BufferGeometry();
  starsGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3));

  const starsMaterial = new THREE.PointsMaterial({
    color: 0xe8f4ff,
    size: 0.36,
    sizeAttenuation: true,
    transparent: true,
    opacity: 0.98,
    depthWrite: false,
    blending: THREE.AdditiveBlending,
  });

  const starsMesh = new THREE.Points(starsGeometry, starsMaterial);
  starsMesh.name = 'stars';
  scene.add(starsMesh);

  return scene;
}

function randomPointsOnSphere(count, innerRadius, outerRadius) {
  const points = [];

  for (let index = 0; index < count; index += 1) {
    const theta = Math.random() * Math.PI * 2;
    const phi = Math.acos((Math.random() * 2) - 1);
    const radius = THREE.MathUtils.lerp(innerRadius, outerRadius, Math.random());

    points.push(
      radius * Math.sin(phi) * Math.cos(theta),
      radius * Math.sin(phi) * Math.sin(theta),
      radius * Math.cos(phi)
    );
  }

  return points;
}
